import { defineStore } from 'pinia';

export interface RidershipPoint { time: string; passengers: number }
export interface TransferSample { station: string; meters: number }
export interface DwellSample { segment: string; seconds: number }

export const useMetroDataStore = defineStore('metroData', {
  state: () => ({
    ridership: <RidershipPoint[]>[
      { time: '07:30', passengers: 80 },
      { time: '07:45', passengers: 130 },
      { time: '08:00', passengers: 210 },
      { time: '08:15', passengers: 260 },
      { time: '08:30', passengers: 240 },
      { time: '08:45', passengers: 200 },
      { time: '09:00', passengers: 150 }
    ],
    transferDistances: <TransferSample[]>[
      { station: '人民广场', meters: 320 },
      { station: '世纪大道', meters: 410 },
      { station: '虹桥火车站', meters: 550 },
      { station: '徐家汇', meters: 290 },
      { station: '曹杨路', meters: 360 }
    ],
    dwellTimes: <DwellSample[]>[
      { segment: '1号线 上海马戏城→延长路', seconds: 115 },
      { segment: '1号线 延长路→中山北路', seconds: 140 },
      { segment: '1号线 中山北路→上海火车站', seconds: 165 },
      { segment: '1号线 上海火车站→汉中路', seconds: 120 }
    ]
  }),
  getters: {
    peakRidership: (s) => s.ridership.reduce((m, d) => d.passengers > m ? d.passengers : m, 0),
    maxTransfer: (s) => s.transferDistances.reduce((m, d) => d.meters > m ? d.meters : m, 0),
    maxDwell: (s) => s.dwellTimes.reduce((m, d) => d.seconds > m ? d.seconds : m, 0)
  }
});
